(function ($) {

    if ($('.toast-wrap').length) { 
        $(window).scroll(function() {
            if ($(document).scrollTop() > 200) {
                $('.toast-wrap').addClass('is-visible');
            }
            else {
                $('.toast-wrap').removeClass('is-visible');
            }
        });
    }

})(jQuery);